export default "__VITE_ASSET__D6Ni7yWf__"